<template>
    <v-app>
        <v-main class="kp-root-panel-bg">
            <router-view v-if="!routeNeedsAuth" />
            <div v-else>... redirect in progress ...</div>
        </v-main>

        <Toast></Toast>
    </v-app>
</template>

<script>
import Toast from '@/components/Toast.vue';

export default {
    name: 'GuestRootView',
    components: { Toast },
    computed: {
        routeNeedsAuth() {
            return this.$route.meta && this.$route.meta.requiresAuth;
        },
    },
};
</script>
